import { delete$, get$, post$, put$ } from "./default";
import { api } from "../constants/api";

export const getEnrichContactsAPI = (query) => {
    return get$(api.enrich.getAllContacts, query);
};

export const enrichContactsAPI = (data) => {
    return post$(api.enrich.enrichContacts, data);
}; 